import { Form } from "formik";
import styled from "styled-components";

export const BankreaderIframe = styled.iframe`
  display: flex;
  flex-grow: 1;
  border: 0;
  min-height: 650px;
  /* padding-bottom: 20px; */
  margin: 0 -40px;
`;

export const IbanImage = styled.img`
    margin: 15px auto;
    max-height: 250px;
`;

export const IbanForm = styled(Form)`
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  justify-content: center;
`;
